import React, { forwardRef } from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

interface IProps extends TooltipProps {
  border?: boolean;
  borderRadius?: number;
}

const useStyles = makeStyles<IProps>()((theme, props) => ({
  tooltip: {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.custom.white,
    boxShadow: '0px 4px 8px rgba(60, 85, 165, 0.16)',
    ...{
      border: `1px solid ${theme.palette.custom.border.gray}`,
      borderRadius: props?.borderRadius ? props.borderRadius : theme.spacing(0.5),
    },
  },
  arrow: {
    ...(props?.border && {
      '&::before': {
        border: `1px solid ${theme.palette.custom.border.gray}`,
      },
    }),
    color: theme.palette.custom.white,
  },
}));

const LightTooltip = forwardRef((props: IProps, ref: React.Ref<any>) => {
  const { classes } = useStyles(props, {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    props,
  });
  return <Tooltip enterTouchDelay={0} {...props} ref={ref} classes={classes} />;
});

export default LightTooltip;
